export const ChristmasColors = Object.freeze({
  TREE: '#2f7a3a',
  TREE_DARK: '#1f5a2a',
  TREE_LIGHT: '#4a9b52',
  TRUNK: '#6b4423',
  STAR: '#f5c518',
  STAR_DARK: '#a67c00',
  BAUBLE_RED: '#d32f2f',
  BAUBLE_BLUE: '#1e88e5',
  BAUBLE_BLUE_DARK: '#1565c0',
  BAUBLE_GOLD: '#f5c518',
  SNOW: '#ffffff',
  SNOW_LIGHT: '#e3f0fb',
  SNOW_BLUE: '#b9d7ef',
  SNOW_EDGE: '#8fbce0',
  GLOW: '#fff2a8',
  HEADER_TINT: '#f3f8ff',
  LIGHT_WIRE: '#1b3a22',
  LIGHT_SOCKET: '#3a4a3f',
});

export const CHRISTMAS_GRADIENT = `linear-gradient(90deg, ${ChristmasColors.BAUBLE_RED}, ${ChristmasColors.STAR_DARK}, ${ChristmasColors.TREE}, ${ChristmasColors.BAUBLE_BLUE_DARK}, ${ChristmasColors.BAUBLE_RED})`;
